"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var containers = {
    link: function (_a) {
        var className = _a.className, video = _a.video, children = _a.children, to = _a.to;
        return react_1.default.createElement("a", { href: to || process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/videos/" + video.slug, className: storybook_1.Helpers.classNames('storybook-videos-card', className) }, children);
    },
    button: function (_a) {
        var className = _a.className, children = _a.children, onClick = _a.onClick;
        return react_1.default.createElement("button", { onClick: onClick, className: storybook_1.Helpers.classNames('storybook-videos-card', className) }, children);
    },
};
function Card(_a) {
    var _b, _c, _d;
    var className = _a.className, video = _a.video, onClick = _a.onClick, to = _a.to;
    var Container = containers[onClick ? 'button' : 'link'];
    return react_1.default.createElement(Container, { video: video, className: storybook_1.Helpers.classNames('storybook-videos-card', className), onClick: function () { return onClick(video); }, to: to },
        react_1.default.createElement("div", { style: { backgroundImage: "url(" + video.thumbnail + ")" }, className: 'storybook-videos-card-thumbnail' },
            react_1.default.createElement("div", { className: 'storybook-videos-card-shadow' },
                video.sport && react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: 'storybook-videos-card-icon' },
                        react_1.default.createElement(storybook_1.Icons.Icon, { name: video.sport.name })),
                    react_1.default.createElement("span", { className: 'storybook-videos-card-sport' }, video.sport.label)),
                video.type !== 'live' && ((_b = video.length) === null || _b === void 0 ? void 0 : _b.seconds) > 0 &&
                    react_1.default.createElement("span", { className: 'storybook-videos-card-time' }, video.length.seconds.time()))),
        react_1.default.createElement("div", { className: 'storybook-video-info' },
            react_1.default.createElement(storybook_1.Videos.CardTitle, { className: 'storybook-video-title' }, video.title),
            react_1.default.createElement("span", { className: 'storybook-video-views' },
                storybook_1.Helpers.fixedNumbers(video.views),
                " ",
                video.views === 1 ? 'weergave' : 'weergaven',
                ' • ',
                storybook_1.Helpers.uploadTime((_d = (_c = video.date) === null || _c === void 0 ? void 0 : _c.raw) !== null && _d !== void 0 ? _d : video.created_at.raw))));
}
exports.Card = Card;
Card.propTypes = {
    /**
     * Use a different classname mostly for color binding
     */
    className: prop_types_1.default.string,
    video: prop_types_1.default.shape({
        /**
         * The title of the Video
         */
        title: prop_types_1.default.string.isRequired,
        /**
         * The title of the Video
         */
        slug: prop_types_1.default.string.isRequired,
        /**
         * Type of sport or theme of the video
         */
        type: prop_types_1.default.string,
        /**
         * url of the video thumbnail
         */
        thumbnail: prop_types_1.default.string,
        /**
         * Date of the video being placed
         */
        date: prop_types_1.default.object,
        /**
         * Length of the video being placed
         */
        time: prop_types_1.default.string,
    }).isRequired,
};
